<template>
    <RenderSimpleHtmlText>{{ $t('text', { level }) }}</RenderSimpleHtmlText>
</template>

<script>
import { RenderSimpleHtmlText } from '../../../components'

export default {
    name: 'ObjectiveLevelText',
    components: {
        RenderSimpleHtmlText,
    },
    props: {
        objectiveLevel: {
            type: String,
            required: true,
        },
    },
    computed: {
        level() {
            return this.$t(this.objectiveLevel)
        },
    },
    i18n: {
        messages: {
            'en-US': {
                text: '<strong>Level:</strong> {level}',
                personal: 'Personal',
                department: 'Department',
                unit: 'Unit',
            },
            'en-ES': {
                text: '<strong>Nivel:</strong> {level}',
                personal: 'Individual',
                department: 'Equipo',
                unit: 'Organización',
            },
            'pt-BR': {
                text: '<strong>Nível:</strong> {level}',
                personal: 'Individual',
                department: 'Equipe',
                unit: 'Organização',
            },
        },
    },
}
</script>
